import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DepartmentIdResponse } from '@edtech-ui/core/models/admin-panel/department-management/get-batch-department';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DepartmentManagementService {

	apiUrl = environment.departmentApiUrl;
	constructor(private http: HttpClient) { }

	getDepartmentForBatch(): Observable<DepartmentIdResponse> {
		return this.http.get<DepartmentIdResponse>(`${this.apiUrl}/departments`);
	}

}